<template>
  <section class="flex align-middle justify-center sm:py-40">
    <Card class="w-448 max-w-screen p-24">
      <h1 class="text-h1 mb-16">{{ heading }}</h1>
      <template v-if="verificationEmailSent">
        <p class="pb-16 text-body text-grey-body">
          Please check your email at {{ workEmail }} to create your new, full-access account.
        </p>
      </template>
      <template v-else-if="manualFallback">
        <p class="pb-16 text-body text-grey-body">
          Our Customer Success team will review your request and verify your employer eligibility.
        </p>
        <p class="pb-16 text-body text-grey-body">
          You will receive an email at your entered work address within <strong>1–2 business days</strong> with next steps. During
          this period, you won't be able to message sitters directly.
        </p>
        <p class="pb-16 text-body text-grey-body">
          If you have an urgent care need, please contact us by email at
          <a href="mailto:support@sittercity.com" class="underline">support@sittercity.com</a>.
        </p>
      </template>
      <p v-else class="pb-16 text-body text-grey-body">
        Our Customer Success team will validate your request. You will receive a confirmation email in 1-2 business days.
      </p>
      <Button
        id="continue-registration-btn"
        class="w-full"
        variant="primary"
        :value="continueButtonLabel"
        size="medium"
        :to="{ name: 'registration-care-type' }"
      />
    </Card>
  </section>
</template>

<script lang="ts">
import Card from '@/components/card/Card.vue';
import Button from '@/components/button/Button.vue';
import { getItem, removeItem, STORAGE_KEYS } from '@/lib/storage';

export default {
  name: 'UpgradeRequestSent',
  components: {
    Card,
    Button,
  },
  computed: {
    upgradePath(): string {
      return (this.$route.query.upgradePath as string) || 'manual';
    },
    workEmail(): string {
      return getItem(STORAGE_KEYS.CORPORATE_UPGRADE_WORK_EMAIL, 'session') || '';
    },
    verificationEmailSent(): boolean {
      return this.upgradePath === 'verification';
    },
    manualFallback(): boolean {
      return this.upgradePath === 'manual_fallback';
    },
    heading(): string {
      return this.verificationEmailSent ? "We've confirmed your eligibility" : 'Upgrade request sent';
    },
    continueButtonLabel(): string {
      return this.verificationEmailSent || this.manualFallback ? 'Continue' : 'Continue signing up';
    },
  },
  beforeUnmount() {
    removeItem(STORAGE_KEYS.CORPORATE_UPGRADE_WORK_EMAIL, 'session');
  },
};
</script>
